import { useRef } from 'react';
import { useScaleCanvas } from '../../use-scale-canvas';
import repPurposeImage from '../OrgImages/reppurposeimage.png';
import sparkleYellow from '../OrgImages/sparkleyellow.svg';

const CANVAS_W = 640;
const CANVAS_H = 660;

export const OrgPartnerAssociationShowcase = () => {
  const sectionRef = useRef<HTMLElement>(null);
  const { wrapperStyle, canvasStyle } = useScaleCanvas(sectionRef, CANVAS_W, CANVAS_H, 'contain');

  return (
    <section ref={sectionRef} className='relative h-full w-full overflow-hidden bg-secondary-brand-25'>
      <div className='flex h-full w-full justify-center'>
        <div style={wrapperStyle}>
          <div style={canvasStyle}>
            <div
              className='absolute shadow-none'
              style={{ top: 43, left: 60, width: 504 }}
            >
              <img
                src={repPurposeImage}
                alt=''
                loading='lazy'
                className='object-cover shadow-none'
              />
            </div>

            <img
              src={sparkleYellow}
              alt=''
              className='absolute'
              style={{ top: 360, left: 0, width: 200, height: 200 }}
            />

            <h1
              className="absolute m-0 text-display-md font-bold text-gray-700"
              style={{ left: 32, top: 520, width: 590 }}
            >
              Purpose is powerful—partnership <br />
              makes it unstoppable
            </h1>
          </div>
        </div>
      </div>
    </section>
  );
};

